/** Labels a `loan-types` key; anything else, such as free text, is left blank. */
export const formatLoanType = (
	loanType: string | undefined,
	loanTypeOptions: Record<string, string>
) => {
	switch (loanType) {
		case "card":
			return loanTypeOptions.card;
		case "loan":
			return loanTypeOptions.loan;
		default:
			return "";
	}
};
